<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img
              *ngIf="_logoService.iconUrl$ | async as iconUrl"
              [src]="iconUrl"
              alt=""
              height="22"
              onerror="this.style.display='none'"
            />
          </span>
          <span class="logo-lg">
            <img
              *ngIf="_logoService.logoUrl$ | async as logoUrl"
              [src]="logoUrl"
              alt=""
              onerror="this.style.display='none'"
            />
          </span>
        </a>

      </div>

      <button
        type="button"
        class="btn btn-sm px-3 font-size-16 header-item"
        id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)"
      >
        <i class="fa fa-fw fa-bars"></i>
      </button>
    </div>

    <div class="d-flex">
      <div class="dropdown d-inline-block">
        <button
          type="button"
          class="btn header-item noti-icon"
          id="page-header-notifications-dropdown"
          (click)="$event.stopPropagation()"
        >
          <i
            class="bx bx-bell"
            [ngClass]="{ 'bx-tada': notificationsCount > 0 }"
          ></i>
          <span
            class="badge bg-danger rounded-pill"
            *ngIf="notificationsCount"
            >{{ notificationsCount }}</span
          >
        </button>
      </div>
      <div class="dropdown d-inline-block" dropdown>
      <button
        type="button"
        class="btn header-item d-flex align-items-center"
        dropdownToggle
        id="page-header-language-dropdown"
      >
        <i class="bx bx-globe font-size-18 me-1"></i>

        <span class="d-none d-md-inline-block ms-1">
          {{ selectedLanguage }}
        </span>

        <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
      </button>

      <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
        <a
          class="dropdown-item"
          style="cursor: pointer;"
          *ngFor="let language of languages"
          (click)="changeLanguage(language); $event.preventDefault();"
        >
          {{ language.name }}
        </a>
      </div>
    </div>
      <div class="dropdown d-inline-block" dropdown>
        <button
          type="button"
          class="btn header-item d-flex align-items-center"
          dropdownToggle
          id="page-header-user-dropdown"
        >
          <div class="avatar-xs">
            <span class="avatar-title rounded-circle bg-custom-primary">
              {{ userInfo?.name | shortName | uppercase }}
            </span>

          </div>
          <span class="d-none d-xl-inline-block ms-1"
            >{{ userInfo?.name }}
          </span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>

        <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
          <!-- item-->
          <p
            class="text-muted text-truncate dropdown-item mb-0"
            role="button"
            *ngIf="userInfo.code"
            [cdkCopyToClipboard]="userInfo.code"
            (cdkCopyToClipboardCopied)="onClipboardCopy($event, userInfo.code)"
          >
            <i class="bx bx-user font-size-16 align-middle me-1"></i>
            {{ userInfo.code }}
            <i class="far fa-copy copy-link"></i>
            <span class="copy-btn-text" *ngIf="copiedValue == userInfo.code">{{
              showCopiedMessage
            }}</span>
          </p>
          <a
            class="dropdown-item"
            href="javascript: void(0);"
            [routerLink]="'/profile'"
            ><i class="bx bx-cog font-size-16 align-middle me-1"></i>
            {{variable.settings}}</a
          >
          <a
            class="dropdown-item text-danger"
            href="javascript: void(0);"
            (click)="logout()"
            ><i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            {{ variable.buttonLogout }}</a
          >
        </div>
      </div>
    </div>
  </div>
</header>
